/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (window.innerWidth <= 768) {
  document.querySelectorAll('.Product__Gallery').forEach(function(slideshow) {
    slideshow.addEventListener('click', function() {
      const zoomIcon = slideshow.querySelector('.zoom-icon');
      if (zoomIcon) {
        zoomIcon.click();
      }
    });
  });
}
/*
 * Product card image sliders (snippets/product-item-new.liquid): only the first image is lazy-loaded up
 * front. The others carry Image--lazyDeferred and join lazysizes once their slide is current or next to it.
 * Without this every slide and slick clone loaded, ~340 images on a product page's rec carousels.
 */
(function () {
  function promoteSlideImages(slider) {
    $(slider).find('.slick-active').each(function () {
      $(this).prev().add(this).add($(this).next())
        .find('.Image--lazyDeferred')
        .removeClass('Image--lazyDeferred')
        .addClass('Image--lazyLoad');
    });
  }

  $(document).on('init afterChange', '.slick-items', function (event) {
    promoteSlideImages(event.currentTarget);
  });

  // Sliders that started before this script ran
  $('.slick-items.slick-initialized').each(function () {
    promoteSlideImages(this);
  });
})();
/*
 * Promotion price chip (snippets/promo-price.liquid) is rendered for the first variant. Swap in the selected
 * variant's discounted price, as variants can be priced differently (e.g. fuller cup sizes).
 */
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  var section = event.target.closest('.shopify-section') || document;

  if (!variant) {
    return;
  }

  section.querySelectorAll('.promo-price[data-promo-prices]').forEach(function (chip) {
    var amount = chip.querySelector('.promo-price__amount');
    var price = JSON.parse(chip.getAttribute('data-promo-prices'))[variant.id];

    if (amount && price) {
      amount.innerHTML = price; // Liquid's money output, wrapped in <span class=money>
    }
  });
});
